import { ChevronDown } from '@patrianna-icons/material-icons'
import cx from 'classnames'
import { useState } from 'react'
import type { ReactNode } from 'react'

import classes from './styles.module.scss'

type Props = {
  title: ReactNode
  content: ReactNode
  className?: string
  classNameIsOpened?: string
  classNameTitleBlock?: string
}

export function Accordion({ title, content, className, classNameTitleBlock, classNameIsOpened }: Props) {
  const [isOpened, setIsOpened] = useState<boolean>(false)

  const handleToggle = () => setIsOpened(!isOpened)

  return (
    <div className={cx(classes.root, className, { [classes.rootIsOpened]: isOpened, [classNameIsOpened]: isOpened })}>
      <div className={cx(classes.titleBlock, classNameTitleBlock)} onClick={handleToggle}>
        <div className={classes.title}>{title}</div>
        <ChevronDown className={classes.arrow} />
      </div>

      <div className={classes.content}>{content}</div>
    </div>
  )
}
